<template>
  <div v-if="basket" class="basket-notes card card-body">
    <h5>Do you have a discount code?</h5>

    <input
      class="form-control mb-3"
      v-model="discountCode"
      placeholder="Discount code"
      @keydown.enter="applyDiscount"
    />

    <button
      class="btn btn-secondary text-center"
      :disabled="loading"
      @click="applyDiscount"
      v-if="!basket.discount_id"
    >Apply Discount
    </button>

    <button
      class="btn btn-danger ms-2"
      type="button"
      :disabled="loading"
      @click="removeDiscount"
      v-else
    >
      Remove Discount
    </button>

    <div class="mt-3" v-if="discounts.length > 0">
      <div class="discount-box" @click="removeDiscount(discount[0])" v-for="discount in discounts" :key="discount[0]">
        {{ discount[1] }} <span class="removeX">x</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscountComponent",

  props: {
    preloadBasket: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      basket: null,
      discountCode: "",
      loading: false,
      discounts: []
    };
  },

  watch: {
    preloadBasket: function (newValue, oldValue) {
      if (newValue) {
        this.basket = newValue;
      }
    },

    basket: function (newValue, oldValue) {
      if (newValue) {
        // Fetch the discounts
        axios.post('/api/v1/basket/get_discounts', {'basket': this.basket})
          .then(response => {
            if (response.data.success) {
              if (response.data.discounts.length > 0) {

                // Transform the discounts array into an array of arrays [discount_id: discount_code]
                const formattedDiscounts = response.data.discounts.map(discount => {
                  return [discount.id, discount.code];
                });

                // Assign the formatted discounts to the component property
                this.discounts = formattedDiscounts;
              }
            } else {
              this.discounts = []
            }
          })
          .catch(error => {
            console.error('Error fetching discounts:', error);
          });
      }
    },
  },

  created() {
    if (this.preloadBasket) {
      this.basket = this.preloadBasket;
    }
  },

  methods: {
    applyDiscount() {
      this.loading = true;

      clearInterval(window.pollBasketInterval);

      axios
        .post("/api/v1/basket/apply_discount", {
          discount_code: this.discountCode,
        })
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },

    removeDiscount(id) {
      this.loading = true;
      this.discounts = this.discounts.filter(item => !item.some(element => element === id));

      clearInterval(window.pollBasketInterval);

      axios
        .post("/api/v1/basket/remove_discount", {'id': id})
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
}
</script>

<style scoped>
.discount-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.discount-box {
  background-color: #3C441E;
  color: white;
  padding: 10px;
  margin-bottom: 0.75rem;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:last-child {
    margin-bottom: 0;
  }
}

.removeX {
  background-color: #B9BDA5;
  color: #3C441E;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  font-weight: bold;
}

</style>
